"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M7.41 8l3.29-3.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-4 4C5.11 7.47 5 7.72 5 8c0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L7.41 8z"];
//# sourceMappingURL=chevron-left.js.map